/**
 * `state` round-trips through the OAuth redirect as plaintext in the URL and WorkOS cannot
 * validate it, so what comes back is untrusted input. Resolving it against the app's own origin
 * and rejecting anything that lands elsewhere is what stops a crafted link from turning sign-in
 * into an open redirect (or a `javascript:` URI).
 *
 * The origin is passed in rather than read from `window` so this stays a pure function.
 */
export const readReturnToPath = (
  state: Record<string, any> | null | undefined,
  origin: string,
): string | null => {
  const returnTo = state?.returnTo

  if (typeof returnTo !== 'string' || !returnTo) {
    return null
  }

  let url: URL

  try {
    url = new URL(returnTo, origin)
  } catch {
    return null
  }

  if (url.origin !== origin) {
    return null
  }

  // Rebuilt from the parsed URL rather than passed through, so a value like `//evil.com` cannot
  // survive as a protocol-relative path.
  return `${url.pathname}${url.search}${url.hash}`
}
